<template>
    <div>
        <external-email-project-document-select-modal ref="ExternalEmailProjectDocumentSelectModal" :project="project"></external-email-project-document-select-modal>
        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
            <span>External Email <i v-if="loading" class="fa fa-refresh fa-spin"></i></span>
            <div class="pull-right hidden md:inline">
                <button class="btn btn-sm btn-dark shadow-none" type="button" @click="getData();getProjectSequences()">
                        <i class="fa fa-refresh"></i> Refresh
                </button>
                <button class="btn btn-sm btn-light shadow-none" type="button" @click="composing=true" :disabled="!canEdit">
                    <i class="fa fa-envelope"></i> Compose Email
                </button>
            </div>
            <button class="border-teal bg-white font-semibold p-1 rounded-full text-teal ml-1 md:hidden pull-right"
                    id="externalEmailOptionsDropdown" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                <i class="fa fa-caret-down mx-2"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="externalEmailOptionsDropdown">
                <button @click.prevent="getData" class="dropdown-item">
                    Refresh
                </button>
                <button @click.prevent="composing=true" class="dropdown-item">
                    Compose Email
                </button>
            </div>
        </div>

        <div class="flex justify-center my-3" v-if="error">
            <div class="alert alert-danger -mb-6" role="alert">
               <span class="hidden lg:inline">
                   Please re-authenticate your e-mail. <a href="/settings">settings</a>
                </span>
            </div>
        </div>

        <div class="flex justify-center my-3" v-if="!checkConn">
            <div class="alert alert-danger -mb-6 email-connection" role="alert" >
               <span class="hidden lg:inline">
                  Your email is not connected please click <a href="/settings">here</a> to connect.  </span>
            </div>
        </div>


        <div class="py-4 px-3 flex flex-wrap flex-lg-nowrap items-stretch w-full">
            <div class="w-full lg:w-1/2 p-2">
                <table class="text-left w-full border-collapse">
                    <thead class="bg-teal">
                        <th class="py-3 px-6 font-bold uppercase text-xs text-white border-b border-grey-light text-center hidden md:table-cell">
                            <i class="fa fa-paperclip"></i>
                        </th>
                        <th class="py-3 px-6 font-bold uppercase text-xs text-white border-b border-grey-light">
                            Subject
                        </th>
                        <th class="py-3 px-6 font-bold uppercase text-xs text-white border-b border-grey-light">
                            From
                        </th>
                        <th class="py-3 px-6 font-bold uppercase text-xs text-white border-b border-grey-light text-center hidden md:table-cell">
                            <i class="fa fa-exclamation"></i>
                        </th>
                        <th class="py-3 px-6 font-bold uppercase text-xs text-white border-b border-grey-light hidden md:table-cell">
                            Date
                        </th>
                    </thead>
                    <tbody v-if="allEmails.length > 0">
                        <tr v-for="email in allEmails" :key="email.id" class="cursor-pointer" @click="loadEmailBody(email)" :class="(active_email && active_email !== undefined && active_email.id === email.id) ? 'active-email-style' : ''">
                            <td class="py-3 px-6 border-b border-grey-light text-xs text-center hidden md:table-cell">
                                <i class="fa fa-paperclip" v-if="email.hasAttachments && !email.attachmentLoading" @click="downloadAttachments(email)"></i>
                                <i v-if="email.hasAttachments && email.attachmentLoading" class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i>
                            </td>
                            <td class="pl-2 py-3 border-b border-grey-light text-xs">
                                {{ formattedSubject(email.subject) }}
                                <i class="fa fa-eye" v-if="email.isRead" style="color: #0a8c62"></i>
                                <i class="fa fa-eye-slash" v-if="email.isRead===false" style="color: grey"></i>
                            </td>
                            <td class="pl-2 py-3 border-b border-grey-light text-xs">
                                <div>{{email.from_email}}</div>
                            </td>
                            <td class="py-3 px-6 border-b border-grey-light text-xs text-center hidden md:table-cell">
                                <div v-if="email.importance === 'high'">
                                    <i class="fa fa-exclamation text-red"></i>
                                </div>
                            </td>
                            <td class="pl-2 py-3 border-b border-grey-light text-xs hidden md:table-cell" :class="{'sequence-background' : email.is_sequence}">
                                {{ email.sending_time }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="hidden lg:flex border-1 border-grey mr-4"></div>
            <div class="w-full lg:w-1/2">
                <hr class="lg:hidden">
                <div v-if="composing">
                    <div class="flex flex-wrap">
                        <div class="w-1/2 lg:my-2 w-full">
                            <div class="w-full mt-2 mt-lg-0">
                                <div>
                                    <label for="to"
                                    :class="{'text-red' : errors.to}"
                                    >To (example@email.com)</label>
                                    <span class="float-right">
                                        <span v-if="hasSequencesAccess">
                                            <b-button
                                                v-if="showStopButton"
                                                class="bg-primary template-button ml-2"
                                                pill
                                                variant="info"
                                                @click.stop.prevent="stopEmailSequence"
                                            >Stop Sequence</b-button>
                                            <b-button
                                                class="bg-primary template-button ml-2"
                                                pill
                                                variant="info"
                                                type="button"
                                                data-toggle="modal"
                                                data-target="#selectContactModal"
                                            >Sequences</b-button>
                                        </span>
                                        <b-button
                                            class="bg-primary template-button"
                                            pill
                                            variant="info"
                                            @click.stop.prevent="openEmailTemplateModal"
                                        >Templates</b-button>
                                    </span>
                                </div>
                                <div class="row mx-0 w-full md:w-auto self-center">
                                    <input class="form-control col-md-9"
                                        :class="errors.to ? 'is-invalid' : null"
                                        @input="() => errors.to = null"
                                        type="text" name="to" id="mail_to" v-model="emailForm.to">
                                    <button class="form-control btn btn-primary col-md-2 md:ml-1 md:mr-1" @click.prevent.stop="openNewModalEmail('to')">
                                        <i class="fa fa-user-circle-o"></i>
                                    </button>
                                </div>
                                <small v-if="errors.to" class="text-danger">
                                    {{ errors.to }}
                                </small>
                            </div>
                        </div>
                        <div class="lg:my-2 w-full mt-2 mt-lg-0">
                            <div>
                                <div>
                                    <label for="cc"
                                    :class="{'text-red' : errors.cc}"
                                    >CC (examplecc@mail.com)</label>
                                </div>
                                <div class="row mx-0 w-full md:w-auto self-center">
                                    <input class="form-control col-md-9" :class="errors.cc ? 'is-invalid' : null"
                                    type="text" name="cc" id="mail_cc" v-model="emailForm.cc">
                                    <button class="form-control btn btn-primary col-md-2 md:ml-1" @click.stop.prevent="openNewModalEmail('cc')">
                                        <i class="fa fa-user-circle-o"></i>
                                    </button>
                                </div>
                                <small v-if="errors.cc" class="text-danger">
                                    {{ errors.cc }}
                                </small>
                            </div>
                        </div>
                        <div class="w-full mt-2 mt-lg-0">
                               <b-form-group
                                    label="Subject"
                                    label-for="subject"
                                    :invalid-feedback="errors.subject"
                                    :state="!errors.subject"
                                >
                                    <b-input-group
                                        :append="subjectSufix()"
                                    >
                                        <b-form-input
                                            class="form-control"
                                            v-model="emailForm.subject"
                                            :state="!errors.subject ? null : false"
                                            @input="()=>errors.subject = null"
                                            trim
                                        />
                                    </b-input-group>
                                </b-form-group>

                        </div>
                        <div class="w-full lg:mb-2 mt-2">
<!--                            <textarea class="form-control" cols="20" rows="8"
                                :class="errors.body ? 'is-invalid' : null"
                                @input="() => errors.body = null"
                                type="text" name="body" id="mail_body" v-html="emailForm.body"></textarea>-->
<!--                            <ckeditor-container  :class="errors.body ? 'is-invalid' : null"
                                                @input="() => errors.body = null" id="comment" v-model="emailForm.body"
                                                mentionFrom="name"></ckeditor-container>-->
                            <ckeditor-container-email
                                :class="errors.body ? 'is-invalid' : null"
                                @input="() => (errors.body = null)"
                                id="comment"
                                v-model="emailForm.body"
                                mentionFrom="name"
                            ></ckeditor-container-email>
                            <!-- <vue-text-editor :text-binding="emailForm.body" :class="errors.body ? 'is-invalid' : null"-->
                            <!-- @input="() => errors.body = null" v-on:emailBodyText="emailBodyText"></vue-text-editor>-->
                            <small v-if="errors.body" class="text-danger">
                                {{ errors.body }}
                            </small>
                        </div>
                        <div class="lg:my-2 w-full mt-2 mt-lg-0">
                                <label for="email-file-attachment" class="mt-1 mb-1" :class="{'text-red' : errors.file}">
                                    Files
                                </label>
                            <div class="row mx-0 w-full md:w-auto self-center mb-1">
                                <label v-if="uploadFiles.length == 0" for="email-file-attachment" class="cursor-pointer w-full border-1 bg-grey-lightest p-3 text-center" :class="(selectedFiles.length > 0)? 'col-md-12':'col-md-6'" @dragover="dragover" @dragleave="dragleave" @drop="drop" id="dropContainer">
                                    <i class="fa fa-upload fa-2x mb-4" aria-hidden="true"></i>
                                    <br>
                                    <span class="text-black text-lg">
                                            Click or drag to upload file
                                        </span>
                                    <br>
                                    <span class="text-grey-dark text-sm">
                                            Support for a single or bulk upload
                                        </span>
                                </label>
                                <div v-else class="w-full border-1 bg-white px-2 py-1 text-left mb-2" @dragover="dragover" @dragleave="dragleave" @drop="drop" id="dropList">
                                    <div class="row p-0 m-0 text-sm text-truncate pb-1 pt-1" :class="(index == uploadFiles.length-1)? 'border-b-0':'border-b-1'" v-if="uploadFiles.length > 0" v-for="(uploadFile, index) in uploadFiles">
                                        <div class="col-11 p-0 m-0">
                                            {{ uploadFile.name }}
                                        </div>
                                        <div class="col-1 text-right">
                                            <i class="fa fa-trash-o cursor-pointer text-red" @click="removeFromUploadFile(uploadFile, index)" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                </div>
                                <label v-if="selectedFiles.length == 0" for="email-file-selection-form-project-documents" class="cursor-pointer w-full border-1 bg-grey-lightest p-3 text-center" :class="(uploadFiles.length > 0)? 'col-md-12':'col-md-6'" id="dropContainer1" @click="selectProjectDocumentsModal()">
                                    <i class="fa fa-folder-o fa-2x mb-4" aria-hidden="true"></i>
                                    <br>
                                    <span class="text-black text-lg">
                                            Click to select files from project documents
                                        </span>
                                    <br>
                                    <span class="text-grey-dark text-sm">
                                            Support for a single or bulk files
                                        </span>
                                </label>
                                <div v-else class="w-full border-1 bg-white px-2 py-1 text-left mb-2" @dragover="dragover" @dragleave="dragleave" @drop="drop" id="dropList">
                                    <div class="row p-0 m-0 text-sm text-truncate pb-1 pt-1" :class="(index == selectedFiles.length-1)? 'border-b-0':'border-b-1'" v-if="selectedFiles.length > 0" v-for="(selectedFile, index) in selectedFiles">
                                        <div class="col-11 p-0 m-0">
                                            {{ selectedFile.name }}
                                        </div>
                                        <div class="col-1 text-right">
                                            <i class="fa fa-trash-o cursor-pointer text-red" @click="removeFromSelectedFile(selectedFile, index)" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="input-group cursor-pointer rounded-sm p-2 text-grey-darkest text-sm border-1 field-height-update w-full email-file-attachment-class">
                                    <label class="input-group-text rounded-none" for="email-file-attachment">Select files</label>
                                    <label tabindex="0" class="form-control">
                                        {{(uploadFiles.length == 0) ? 'Click here to Select file(s)' : (uploadFiles.length == 1) ? '1 file is selected'  : uploadFiles.length +' files are selected' }}
                                        <input type="file" class="invisible" ref="file" id="email-file-attachment" @change="attach($event)" name="attach" multiple>
                                    </label>
                                </div>
                            </div>
                            <small v-if="errors.file" class="text-danger">
                                {{ errors.file }}
                            </small>
                        </div>
                        <div class="lg:my-2 w-full mt-2 mt-lg-0">
                                <label for="to" class="mt-1 mb-1" :class="{'text-red' : errors.to}">
                                    Priority
                                </label>
                            <div class="row mx-0 w-full md:w-auto self-center">
                                <select class="cursor-pointer rounded-sm p-2 text-grey-darkest text-sm focus:outline-none border-1 field-height-update w-full" v-model="emailForm.importance">
                                    <option value="low">Low</option>
                                    <option value="normal">Normal</option>
                                    <option value="high">High</option>
                                </select>
                            </div>
                            <small v-if="errors.cc" class="text-danger">
                                {{ errors.cc }}
                            </small>
                        </div>
                        <div class="w-full">
                            <div class="row mx-0 lg:ml-3 mt-2">
<!--                                <input type="file" @change="attach($event)" name="attach" class="btn btn-primary col-12 col-md-6 md:pr-1 col-lg-6 col-xl-3 mt-2 mt-lg-0">-->
<!--                                <select class="form-control col-12 col-md-6 col-xl-3 xl:pr-1 mt-2 mt-lg-0" v-model="emailForm.importance">-->
<!--                                    <option value="low">Low</option>-->
<!--                                    <option value="normal">Normal</option>-->
<!--                                    <option value="high">High</option>-->
<!--                                </select>-->
                                <button class="btn btn-primary mt-2 mt-lg-0 pr-1 col-6 col-xl-2 xl:mt-1 mr-1" @click.prevent="send" :disabled="isSendEmailBtnDisabled">
                                    <i class="fa fa-paper-plane-o mr-2"></i> {{ sendEmailBtnText }}
                                </button>
                                <button class="btn btn-secondary mt-2 mt-lg-0 col-6 col-xl-2 xl:mt-1" @click.prevent="composing = false">
                                    <i class="fa fa-times-circle-o mr-2"></i> Cancel
                                </button>
                            </div>
                        </div>
                    </div>


                </div>
                <div v-if="active_email && !composing">
                    <div class="flex w-full items-start mb-3">
                        <div class="hidden md:flex">
                            <i class="fa fa-3x fa-user-circle-o mr-2"></i>
                        </div>
                        <div>
                            <p><span class="md:hidden">From </span>{{active_email.from_email}}</p>
                            <p class="text-grey">
                                To {{active_email.to_email}}
                            </p>
                        </div>
                    </div>
                    <div class="max-email-height">
                        <div v-html="active_email.body" class=""></div>
                    </div>
                </div>
                <div v-if="!composing && !active_email" class="my-5">
                    <div class="alert alert-primary" role="alert">
                        Click "Compose Email" to start a new email, or on email from to list to read it
                    </div>
                </div>
            </div>
        </div>
        <div id="selectContactModal" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">
                            Select contact to enter in sequence
                        </h4>
                        <button
                            type="button"
                            dusk="modal-close-button"
                            class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                            data-dismiss="modal"
                        >
                            close
                        </button>
                    </div>
                    <div class="modal-body">
                        <multiselect
                            id="generateProposal"
                            v-model="selectedContactForSequence"
                            :options="allContacts"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="false"
                            :preserve-search="false"
                            :taggable="false"
                            open-direction="below"
                            placeholder="Pick a Contact"
                            :showLabels="false"
                            label="name"
                            track-by="id"
                            :preselect-first="false"
                        >
                        </multiselect>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            id="save-proposal-generator"
                            name="save-contact-selected"
                            @click.prevent="openEmailSequenceModal"
                            class="btn btn-outline-primary rounded-full"
                        >
                            Select
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal" id="exampleModalEmail" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content" style="border-radius: 12px; overflow: hidden;width: 400px;">
                    <div class="modal-header">
                        <div class="row">
                            <div class="col-md-12" style="text-align: center; font-size:20px; margin-top: 10px;">Add Emails</div>
                            <div class="col-md-12" style="text-align: center; margin-top: 32px;">
                                <button type="button" class="btn btn-primary" style="padding: 20px;box-shadow: #989797 0px 0px 5px 2px;margin-right: 12px;"
                                        @click="openNewCompanyContactModal"> Company Contacts</button>
                                <button type="button" class="btn btn-primary" style="padding: 20px;box-shadow: #989797 0px 0px 5px 2px;"
                                        @click="openEmailContactModal">Email Contacts</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <email-contacts-modal ref="EmailContactModal" :exchange="exchange" :externalEmailService="externalEmailService" v-on:set-emails="setEmails"></email-contacts-modal>
        <company-contacts-modal ref="CompanyContactsModal" :exchange="exchange" v-on:set-emails="setEmails"></company-contacts-modal>
        <email-template-modal-ckeditor ref="EmailTemplateModal" v-on:addTemplateToEmail="addTemplateToEmail" :allFields="allFields" :isAutomation="false" :change-order-key="changeOrderKey"></email-template-modal-ckeditor>
<!--        <email-template-modal ref="EmailTemplateModal" v-on:addTemplateToEmail="addTemplateToEmail"></email-template-modal>-->
        <sequence-modal ref="EmailSequenceModal" :project="project" v-on:addSequenceToEmail="addSequenceToEmail" :selectedContactForSequence="selectedContactForSequence" :allFields="allFields" :subSuffix="subSuffix"></sequence-modal>
    </div>
</template>


<script>

import Multiselect from "vue-multiselect";
import ExternalEmailProjectDocumentSelectModal from "./external-email-project-document-select-modal.vue";
export default {
    name: 'external-email-section',
    components: {ExternalEmailProjectDocumentSelectModal, Multiselect},
    props: ['project', 'email', 'canEdit', 'allContacts', 'hasSequencesAccess', 'exchange', 'externalEmailService', 'changeOrderKey', 'changeOrders', 'quickBookAccess', 'team', 'salesActivities', 'fieldLabels', 'projectDataFieldVisibility'],
    data() {
        return {
            selectedContactForSequence: null,
            emails: [],
            checkConn: false,
            projectEmails: [],
            composing: false,
            active_email: null,
            type:'',
            emailForm: {
                to: '',
                cc: '',
                subject: ``,
                attachment: [],
                body: '',
                importance: 'low',
                attachmentIds: [],
            },
            errors: {
                to: null,
                subject: null,
                body: null
            },
            loading: false,
            error: false,
            allFields: [],
            customFields: [],
            projectFields:[
                {
                    optionTypes: 'Project Fields',
                    optionValues: [
                        {
                            id: 7,
                            button: 'addContact',
                            text: 'Project Contact Full Name',
                            buttonCode: 'replaceContact'
                        },
                        {
                            id: 0,
                            button: 'addFirstName',
                            text: 'Project Contact First Name',
                            buttonCode: 'replaceFirstName'
                        },
                        {
                            id: 8,
                            button: 'addEmail',
                            text: 'Project Contact Email',
                            buttonCode: 'replaceEmail'
                        },
                        {
                            id: 9,
                            button: 'addPhone',
                            text: 'Project Contact Phone',
                            buttonCode: 'replacePhone'
                        },
                        {
                            id: 28,
                            button: 'addCell',
                            text: 'Project Contact Cell',
                            buttonCode: 'replaceCell'
                        },
                        {
                            id: 29,
                            button: 'addFax',
                            text: 'Project Contact Fax',
                            buttonCode: 'replaceFax'
                        },
                        {
                            id: 1,
                            button: 'addYourName',
                            text: 'My Name',
                            buttonCode: 'replaceYourName'
                        },
                        {
                            id: 2,
                            button: 'addProjectName',
                            text: 'Project Name',
                            buttonCode: 'replaceProjectName'
                        },
                        {
                            id: 3,
                            button: 'addAddress',
                            text: 'Address',
                            buttonCode: 'replaceAddress'
                        },
                        {
                            id: 4,
                            button: 'addCity',
                            text: 'City',
                            buttonCode: 'replaceCity'
                        },
                        {
                            id: 5,
                            button: 'addState',
                            text: 'State',
                            buttonCode: 'replaceState'
                        },
                        {
                            id: 6,
                            button: 'addZip',
                            text: 'Zip',
                            buttonCode: 'replaceZip'
                        },
                        {
                            id: 10,
                            button: 'addBaseBid',
                            text: 'Base Bid',
                            buttonCode: 'replaceBaseBid'
                        },
                        {
                            id: 11,
                            button: 'addContractAmount',
                            text: 'Contract Amount',
                            buttonCode: 'replaceContractAmount'
                        },
                        {
                            id: 12,
                            button: 'addContractDate',
                            text: 'Contract Date',
                            buttonCode: 'replaceContractDate'
                        },
                        {
                            id: 13,
                            button: 'addGrossMargin',
                            text: 'Gross Margin',
                            buttonCode: 'replaceGrossMargin'
                        },
                        {
                            id: 14,
                            button: 'addLabourHours',
                            text: 'Labor Hours',
                            buttonCode: 'replaceLabourHours'
                        },
                        {
                            id: 15,
                            button: 'addDeadDate',
                            text: 'Dead Date',
                            buttonCode: 'replaceDeadDate'
                        },
                        {
                            id: 16,
                            button: 'addSalesStatus',
                            text: (this.projectDataFieldVisibility['sales-status'])? this.getFieldLabel(this.fieldLabels, 'sales-status'):null,
                            buttonCode: 'replaceSalesStatus'
                        },
                        {
                            id: 17,
                            button: 'addMarketingStatus',
                            text: (this.projectDataFieldVisibility['marketing-status'])? this.getFieldLabel(this.fieldLabels, 'marketing-status'):null,
                            buttonCode: 'replaceMarketingStatus'
                        },
                        {
                            id: 18,
                            button: 'addPrebid',
                            text: (this.projectDataFieldVisibility['pre-bid'])? this.getFieldLabel(this.fieldLabels, 'pre-bid'):null,
                            buttonCode: 'replacePrebid'
                        },
                        {
                            id: 19,
                            button: 'addBidDate',
                            text: (this.projectDataFieldVisibility['bid-date'])? this.getFieldLabel(this.fieldLabels, 'bid-date'):null,
                            buttonCode: 'replaceBidDate'
                        },
                        {
                            id: 20,
                            button: 'addLeadSource',
                            text: (this.projectDataFieldVisibility['lead-source'])? this.getFieldLabel(this.fieldLabels, 'lead-source'):null,
                            buttonCode: 'replaceLeadSource'
                        },
                        {
                            id: 21,
                            button: 'addEstimator',
                            text: (this.projectDataFieldVisibility['estimator'])? this.getFieldLabel(this.fieldLabels, 'estimator'):null,
                            buttonCode: 'replaceEstimator'
                        },
                        {
                            id: 22,
                            button: 'addAccountManager',
                            text: (this.projectDataFieldVisibility['account-manager'])? this.getFieldLabel(this.fieldLabels, 'account-manager'):null,
                            buttonCode: 'replaceAccountManager'
                        },
                        {
                            id: 23,
                            button: 'addTakeOffPerson',
                            text: (this.projectDataFieldVisibility['take-off-person'])? this.getFieldLabel(this.fieldLabels, 'take-off-person'):null,
                            buttonCode: 'replaceTakeOffPerson'
                        },
                        {
                            id: 24,
                            button: 'addProductAndServices',
                            text: (this.projectDataFieldVisibility['products-and-services'])? this.getFieldLabel(this.fieldLabels, 'products-and-services'):null,
                            buttonCode: 'replaceProductAndServices'
                        },
                        {
                            id: 25,
                            button: 'addClientProfile',
                            text: (this.projectDataFieldVisibility['client-profile'])? this.getFieldLabel(this.fieldLabels, 'client-profile'):null,
                            buttonCode: 'replaceClientProfile'
                        },
                        {
                            id: 26,
                            button: 'addContractType',
                            text: (this.projectDataFieldVisibility['contract-type'])? this.getFieldLabel(this.fieldLabels, 'contract-type'):null,
                            buttonCode: 'replaceContractType'
                        },
                        {
                            id: 27,
                            button: 'addOffice',
                            text: (this.projectDataFieldVisibility['office'])? this.getFieldLabel(this.fieldLabels, 'office'):null,
                            buttonCode: 'replaceOffice'
                        }
                    ]
                },
                {
                    optionTypes: 'Sales Activities',
                    optionValues: []
                },
                {
                    optionTypes: 'Project Custom Fields',
                    optionValues: []
                }

            ],
            newEmails: [],
            showStopButton: false,
            sendEmailBtnText: 'Submit',
            isSendEmailBtnDisabled: false,
            uploadFiles: [],
            selectedFiles: [],
            projectFieldsRecordDetails: [
                // {
                //     id: 100,
                //     button: 'addCostCode',
                //     text: 'Cost Code',
                //     buttonCode: 'replaceCostCode'
                // },
                {
                    id: 101,
                    button: 'addCompletePercentage',
                    text: 'Completed Percentage',
                    buttonCode: 'replaceCompletePercentage'
                }
            ],
        }
    },
    watch: {
        composing(value) {
            if (value) this.emailForm.to = this.email;
        },
        // 'emailForm.to': function(newValue,oldToValue) {
        //     this.removeSpacesTo();
        // },
        // 'emailForm.cc': function(newValue,oldToValue) {
        //     this.removeSpacesCc();
        // }
    },

    created(){
        // window.setInterval(() => this.getData(), 10000)
    },
    mounted() {
        this.getData();
        this.getProjectSequences();
        this.allFields = this.projectFields;
        this.fetchCustomFields();
        this.checkConnection();

        Bus.$on('openContactModalEmail', data => {
            this.$refs.CompanyContactsModal.close();
            this.$refs.EmailContactModal.open(data);

        });
        Bus.$on('openCompanyContactModalEmail', data => {
            this.$refs.EmailContactModal.close();
            this.$refs.CompanyContactsModal.open(data);

        });

        let dropContainer = $('#dropContainer');
        dropContainer.ondragover = dropContainer.ondragenter = function(evt) {
            evt.preventDefault();
        };

        let dropList = $('#dropList');
        dropList.ondragover = dropList.ondragenter = function(evt) {
            evt.preventDefault();
        };

        if(this.quickBookAccess && this.team.quick_book_complete_percentage){
            this.projectFields[0].optionValues = [...this.projectFields[0].optionValues, ...this.projectFieldsRecordDetails];
        }

        if(this.changeOrders && this.changeOrders.length > 0 && this.changeOrderKey){
            this.changeOrders.forEach((item, index) => {
                let numberToAppend = index+1;
                let data = [
                    {
                        id: 200+numberToAppend,
                        button: 'addContractAmount'+numberToAppend,
                        text: 'Contract Amount '+numberToAppend,
                        buttonCode: 'replaceContractAmount'+numberToAppend
                    },
                    {
                        id: 201+numberToAppend,
                        button: 'addContractDate'+numberToAppend,
                        text: 'Contract Date '+numberToAppend,
                        buttonCode: 'replaceContractDate'+numberToAppend
                    },
                    // {
                    //     id: 202+numberToAppend,
                    //     button: 'addCostCode'+numberToAppend,
                    //     text: 'Cost Code '+numberToAppend,
                    //     buttonCode: 'replaceCostCode'+numberToAppend
                    // },
                    // {
                    //     id: 204+numberToAppend,
                    //     button: 'addLabourHours'+numberToAppend,
                    //     text: 'Labour Hours '+numberToAppend,
                    //     buttonCode: 'replaceLabourHours'+numberToAppend
                    // }
                ];
                this.projectFields[0].optionValues = [...this.projectFields[0].optionValues, ...data];
            });
        }

        if(this.changeOrders && this.changeOrders.length > 0 && this.changeOrderKey && this.team.quick_book_complete_percentage){
            this.changeOrders.forEach((item, index) => {
                let numberToAppend = index+1;
                let data = [
                    // {
                    //     id: 202+numberToAppend,
                    //     button: 'addCostCode'+numberToAppend,
                    //     text: 'Cost Code '+numberToAppend,
                    //     buttonCode: 'replaceCostCode'+numberToAppend
                    // },
                    {
                        id: 203+numberToAppend,
                        button: 'addCompletePercentage'+numberToAppend,
                        text: 'Completed Percentage '+numberToAppend,
                        buttonCode: 'replaceCompletePercentage'+numberToAppend
                    }
                    // {
                    //     id: 204+numberToAppend,
                    //     button: 'addLabourHours'+numberToAppend,
                    //     text: 'Labour Hours '+numberToAppend,
                    //     buttonCode: 'replaceLabourHours'+numberToAppend
                    // }
                ];
                this.projectFields[0].optionValues = [...this.projectFields[0].optionValues, ...data];
            });
        }


        // if(this.team.has_quick_book_access){
        //     let data = [
        //
        //         {
        //             id: 401,
        //             button: 'addCompletePercentage',
        //             text: 'Completed Percentage',
        //             buttonCode: 'replaceCompletePercentage'
        //         }
        //
        //     ];
        //     this.projectFields = [...this.projectFields, ...data];
        // }

        let data = [

            {
                id: 501,
                button: 'addEstimatedContractDate',
                text: 'Estimated Contract Date',
                buttonCode: 'replaceEstimatedContractDate'
            },
            {
                id: 502,
                button: 'addFinalContractAmount',
                text: 'Final Contract Amount',
                buttonCode: 'replaceFinalContractAmount'
            },
            {
                id: 503,
                button: 'addCompanyName',
                text: 'Company Name',
                buttonCode: 'replaceCompanyName'
            },
            {
                id: 504,
                button: 'addCompanyContactFullName',
                text: 'Company Contact Full Name',
                buttonCode: 'replaceCompanyContactFullName'
            },
            {
                id: 505,
                button: 'addCompanyContactFirstName',
                text: 'Company Contact First Name',
                buttonCode: 'replaceCompanyContactFirstName'
            },
            {
                id: 506,
                button: 'addCompanyContactEmail',
                text: 'Company Contact Email',
                buttonCode: 'replaceCompanyContactEmail'
            },
            {
                id: 507,
                button: 'addCompanyContactPhone',
                text: 'Company Contact Phone',
                buttonCode: 'replaceCompanyContactPhone'
            },

        ];

        this.projectFields[0].optionValues = [...this.projectFields[0].optionValues, ...data];


        Bus.$on('updateEmailTemplateFields', data => {
            let salesActivitiesData = [];
            if(this.salesActivities.length > 0){
                this.salesActivities.forEach((item, index) => {
                    let numberToAppend = index+508;
                    salesActivitiesData.push({
                        id: numberToAppend,
                        button: 'add'+item.name.replace(/\b\w/g, char => char.toUpperCase()).replace(/\s+/g, ''),
                        text: item.name,
                        buttonCode: 'replace'+item.name.replace(/\b\w/g, char => char.toUpperCase()).replace(/\s+/g, '')
                    })
                })
            }
            // this.projectFields = [...this.projectFields, ...salesActivitiesData];
            this.projectFields[1].optionValues = [...this.projectFields[1].optionValues, ...salesActivitiesData];
        });

        this.projectFields[0].optionValues = this.projectFields[0].optionValues.filter(item => item['text'] !== null);

    },

    methods:{
        openNewModalEmail(type){
            $('#exampleModalEmail').modal('show');
            this.type = type;
        },
        removeSpacesTo() {
            this.emailForm.to = this.emailForm.to.replace(/\s/g, '');
        },
        removeSpacesCc() {
            this.emailForm.cc = this.emailForm.cc.replace(/\s/g, '');
        },
        checkConnection(){
            axios.get('/email-connection').then((response)=>{
                if(response.data.success!==''){
                    this.checkConn=true
                }
            }).catch(erro=>{
                console.log(erro)
            });
        },
        getData(){
            this.loading = true;
            axios.get(route('external-email.emails') + '?project_id=' + this.project.id)
                .then((data) => {
                    if (data.data.error) {
                        this.loading = false;
                        this.error = true;
                        return;
                    }

                    this.emails = data.data;
                    this.emails.sort((a, b) => new Date(b.receivedDateTime) - new Date(a.receivedDateTime));
                    this.emails = this.emails.map(email => {
                        let recipients = '';
                        email.toRecipients.map(x => {
                            recipients = recipients +','+x.emailAddress.address
                        });

                        return {
                            id: email.id,
                            importance: email.importance,
                            subject: email.subject,
                            body: email.body.content,
                            from_email: email.sender.emailAddress.name,
                            to_email: recipients.replace(/^,/, ''),
                            hasAttachments: email.hasAttachments,
                            sending_time: moment(email.receivedDateTime).format('L LT'),
                            is_sequence: 0,
                            isRead: email.isRead ?? '',
                            attachments: email.attachments,
                            attachmentLoading: false
                        }
                    });

                    this.$emit('refresh-comments');
                    this.loading = false
                })
                .catch(error => {
                    this.loading = false;
                    this.emails = [];
                });
        },

        getProjectSequences(){
            this.showStopButton = false;
            if(this.hasSequencesAccess){
                this.loading = true;
                axios.get(route('api.sequence.get-project-sequences') + '?project_id=' + this.project.id)
                    .then(({data}) => {
                        if(data.data.length > 0){
                            this.showStopButton = true;
                        }
                        this.projectEmails = data.data.map(x=>({...x, sending_time: moment(x.sending_time).format('L LT')}))
                        this.projectEmails = this.projectEmails.sort(function (left, right) {
                            return moment.utc(right.sending_time).diff(moment.utc(left.sending_time))
                        });
                        this.loading = false;
                    })
                    .catch(error => {
                        this.projectEmails = [];
                        this.loading = false;
                    });
            }else{
                this.loading = false;
            }
        },

        send(){
            let self = this;
            self.isSendEmailBtnDisabled = true;
            this.clearEmailErrors();
            self.sendEmailBtnText = 'Sending...';

            const data = new FormData();

            for (let i = 0; i<this.emailForm.attachment.length; i++){
                data.append('attachment[' + i + ']', this.emailForm.attachment[i]);
            }

            for (let i = 0; i<this.selectedFiles.length; i++){
                data.append('attachmentIds[' + i + ']', this.selectedFiles[i].id);
            }

            data.append('cc', this.processEmails(this.emailForm.cc));
            data.append('to', this.processEmails(this.emailForm.to));
            data.append('subject', this.emailForm.subject);
            data.append('body', this.emailForm.body);
            data.append('importance', this.emailForm.importance);
            data.append('project_id', this.project.id);

            axios.post(route('external-email.send'), data)
                .then(
                    (resp) => {
                        // setTimeout(() => this.getData(), 10000)
                        self.isSendEmailBtnDisabled = false;
                        self.sendEmailBtnText = 'Submit';
                        self.composing = false;
                        if (resp.data.message === 'Message failed to send due to authentication.'){
                            self.getToast().fire({
                                type: 'error',
                                title: 'This action can\'t be performed because the account\'s credentials are out of date. Please reauthenticate and try again.'
                            });
                        }else if (resp.data.message === "Message failed to send."){
                            self.getToast().fire({
                                type: 'error',
                                title: 'Message failed to send.'
                            });
                        }
                        else {
                            self.getToast().fire({
                                type: 'success',
                                title: 'Your Email Has Been Sent'
                            });
                        }
                        self.getData();
                        self.getProjectSequences();
                        self.clearEmailForm();
                        self.selectedFiles = [];
                    }
                )
                .catch(
                    (err) => {
                        self.isSendEmailBtnDisabled = false;
                        self.sendEmailBtnText = 'Submit';
                        for (let key in err.response.data.errors) {
                            this.errors[key] = err.response.data.errors[key][0];
                        }

                        if (err.response.status !== 422) {
                            Swal.fire({
                                title             : 'Submit Error',
                                text              : 'The email could not be sent. Please check if the recipient emails are valid and if you are connected to an external email.',
                                type              : 'error',
                                closeOnConfirm    : true,
                                confirmButtonColor: '#01B1AF',
                                confirmButtonText: 'OK!',
                            });
                        }
                    }
                )
        },
        processEmails(emails) {
            const emailArray = emails.split(";");
            const cleanedEmailArray = emailArray.map(email => email.trim());
            return  cleanedEmailArray.join(";");
        },
        toDate(date){
           return moment(date).format("MM/DD/YYYY")
        },

        loadEmailBody(email){
            this.active_email = email
            this.composing    = false;
        },

        openEmailContactModal(type) {
            $('#exampleModalEmail').modal('hide');
            this.$refs.EmailContactModal.open(this.type);
        },
        openNewCompanyContactModal() {
            $('#exampleModalEmail').modal('hide');
            this.$refs.CompanyContactsModal.open(this.type);
        },
        openEmailTemplateModal(){
            this.$refs.EmailTemplateModal.open(true);
        },
        openEmailSequenceModal(){
            if (this.selectedContactForSequence) {
                $("#selectContactModal").modal("hide");
                this.$refs.EmailSequenceModal.open(true);
            }
        },
        setEmails(part) {
            if(part[1] === 'cc') {
                let emailsCC = this.emailForm.cc;
                if (!emailsCC.endsWith(";") && this.emailForm.cc !== '') {
                    this.emailForm.cc = emailsCC + ";";
                } else {
                    this.emailForm.cc = emailsCC;
                }
                return this.emailForm.cc = this.emailForm.cc + part[0].join(";");
            }
            let emailsTo = this.emailForm.to;
            if (!emailsTo.endsWith(";") && this.emailForm.to !== '') {
                this.emailForm.to = emailsTo + ";";
            } else {
                this.emailForm.to = emailsTo;
            }
            return this.emailForm.to = this.emailForm.to + part[0].join(";");
        },

        attach(event) {
            let files = _.union(this.uploadFiles, Object.values(event.target.files));
            if (files.length > 5){
                this.getToast().fire({
                    type: 'error',
                    title: 'Maximum file selection limit reached: Please select up to 5 files only.'
                });
            }else {
                this.uploadFiles = files;
                this.emailForm.attachment = this.uploadFiles;
            }
        },

        formattedSubject(subject)
        {
            return subject === this.subjectSufix() ? this.subjectSufix() : subject.replace(this.subjectSufix() ,"");
        },

        subjectSufix(){
            if(this.externalEmailService && this.externalEmailService === 'nylas') {
                return `(${this.project.name}-${this.project.id})`;
            }
            else {
                return `(${this.project.name} - ${this.project.id})`;
            }
        },

        clearEmailErrors() {
            for (let key in this.errors) {
                this.errors[key] = null
            }
        },

        clearEmailForm() {
            this.uploadFiles = [];
            this.emailForm.attachment = []
            this.emailForm.cc         = ''
            this.emailForm.to         = ''
            this.emailForm.subject    = ''
            this.emailForm.body       = ''
            this.emailForm.importance = 'low'
        },
        addTemplateToEmail(template){
            this.emailForm.body = template.template_text;
        },
        addSequenceToEmail(sequence){
            const data = {
                sequence_id: sequence.id,
                project_id: this.project.id,
                contact_id: this.selectedContactForSequence.id,
                contact_type: this.allContacts.find(x => x.id === this.selectedContactForSequence.id).type
            };

            axios.post(route('api.sequence.apply'), data)
                .then(
                    ({data}) => {
                        if(data.status) {
                            this.getToast().fire({
                                type: 'success',
                                title: data.message
                            })
                            this.getData()
                            this.getProjectSequences()
                        }else{
                            this.getToast().fire({
                                type: 'error',
                                title: data.message
                            })
                        }
                    }
                )
                .catch(
                    (err) => {
                        console.log(err)
                    }
                )
        },
        emailBodyText(val){
            this.emailForm.body = val;
        },
        fetchCustomFields() {
            this.projectFields[0].optionValues = this.projectFields[0].optionValues.filter(item => item.text !== null);
            axios.get(route('api.project-custom-field.index')).then(({data}) => {
                let counter = 29;
                this.customFields = data.data.map(field => {
                    if(field.enabled == 1){
                        const fieldName = field.label_value.replace(/\s+/g, '')
                        counter++;
                        return {
                            id: counter,
                            button: 'add'+fieldName,
                            text: field.label_value,
                            buttonCode: 'replace'+fieldName
                        }
                    }
                });

                if(this.customFields.length > 0){
                    this.customFields = this.customFields.filter(item => item !== undefined);
                }
                // this.projectFields[2].optionValues = this.projectFields[2].optionValues.concat(this.customFields);
                this.projectFields[2].optionValues = this.customFields;
                this.allFields = this.projectFields;
            });
        },
        stopEmailSequence() {
            axios.post(route('api.sequence.stop'), {project_id: this.project.id})
                .then(
                    ({data}) => {
                        if(data.status) {
                            this.showStopButton = false;
                            this.getToast().fire({
                                type: 'success',
                                title: data.message
                            })
                            this.getData()
                            this.getProjectSequences()
                        }else{
                            this.showStopButton = true;
                            this.getToast().fire({
                                type: 'error',
                                title: data.message
                            })
                        }
                    }
                )
                .catch(
                    (err) => {
                        console.log(err)
                    }
                )
        },
        downloadAttachments(email) {
            email.attachmentLoading = true;
            axios.post(route('external-email.attachment-download'), {attachments: email.attachments, projectId: this.project.id})
                .then((data) => {
                    email.attachmentLoading = false;
                    this.getToast(3000).fire({
                        type: 'success',
                        title: 'Attachments successfully synced to Followupcrm'
                    })
                })
                .catch((err) => {
                    email.attachmentLoading = false;
                    console.log(err);
                })
        },
        removeFromUploadFile(uploadFile, index){
            this.uploadFiles.splice(index, 1);
            this.emailForm.attachment = this.uploadFiles;
        },
        dragover(e) {
            e.preventDefault();
            this.isDragging = true;
        },
        dragleave() {
            this.isDragging = false;
        },
        drop(e) {
            e.preventDefault();
            this.$refs.file.files = e.dataTransfer.files;
            this.uploadFiles = [...this.$refs.file.files, ...this.uploadFiles];
            this.emailForm.attachment = this.uploadFiles;
        },
        selectProjectDocumentsModal(){
            this.$refs.ExternalEmailProjectDocumentSelectModal.open();
        },
        removeFromSelectedFile(selectedFile, index){
            this.selectedFiles.splice(index, 1);
            this.emailForm.attachmentIds = this.selectedFiles;
        }
    },
    computed: {
        subSuffix(){
            return `(${this.project.name} - ${this.project.id})`;
        },
        allEmails(){
            return this.emails.concat(this.projectEmails);
        },
    }

}
</script>

<style lang="css">
    .max-email-height{
        max-height: 500px;
        overflow: auto;
    }
    .email-connection{
        margin-right: auto;
        margin-left: 24px;
        padding-right: 90px;
        padding-left: 59px;
        padding-top: 4px;
        background: red;
        color: white;
    }
    .template-button {
        margin-top: -15px;
    }
    .sequence-background{
        background: #FFFD78;
    }
    .cke_editable .projectDataHidden{
        display: none;
    }
    .active-email-style {
        background: #f6e7d2;
    }
</style>
